import { REDUCER } from '../reducers/reducersConst';

let initialState = {
  open: false,
  content: undefined
};
export let drawer = (state = initialState, action) => {
  switch (action.type) {
    case REDUCER.DRAWER.OPEN:
      return {
        ...state,
        open: true
      };
    case REDUCER.DRAWER.CLOSE:
      return {
        ...state,
        open: false
      };
    case REDUCER.DRAWER.SET_CONTENT:
      return {
        ...state,
        content: action.content
      };
    default:
      return state;
  }
};
